<template>
  <div v-if="visible" class="chart-popup-wrapper">
    <div class="chart-popup-mask" @click="close"></div>
    <div class="chart-popup-container">
      <div class="chart-popup__header">
        <span class="chart-popup__title">{{ title }}</span>
        <a @click="close" class="chart-popup__close-btn" title="Close">
          <div><span></span><span></span></div>
        </a>
      </div>
      <div class="chart-popup__content">
        <div v-if="chartData && chartData.datasets && chartData.datasets.length > 0" class="chart-container">
          <Bar v-if="type === 'bar'" :chart-data="chartData" :options="chartOptions"/>
          <Pie v-else-if="type === 'pie'" :chart-data="chartData" :options="pieChartOptions"/>
          <Doughnut v-else-if="type === 'doughnut'" :chart-data="chartData" :options="pieChartOptions"/>
          <LineChartGenerator v-else-if="type === 'line'" :chart-data="chartData" :options="chartOptions"/>
        </div>
        <div v-else class="chart-popup__no-data">
          차트 데이터를 불러올 수 없습니다.
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import {Bar, Pie, Doughnut, Line as LineChartGenerator} from 'vue-chartjs';
  import {
    Chart as ChartJS,
    Title,
    Tooltip,
    Legend,
    BarElement,
    CategoryScale,
    LinearScale,
    ArcElement,
    PointElement,
    LineElement,
  } from 'chart.js';

  ChartJS.register(
      Title, Tooltip, Legend, BarElement, CategoryScale, LinearScale, ArcElement, PointElement, LineElement
  );

  export default {
    name: 'ChartPopup',
    components: {Bar, Pie, Doughnut, LineChartGenerator},
    props: {
      visible: {
        type: Boolean,
        default: false,
      },
      title: {
        type: String,
        default: '차트 상세 보기',
      },
      chartData: {
        type: Object,
        required: true,
      },
      chartOptions: {
        type: Object,
        default: () => ({
          responsive: true,
          maintainAspectRatio: false,
          plugins: {
            legend: {
              display: false, // 범례는 숨김
            },
          },
        }),
      },
      type: {
        type: String,
        default: 'bar',
      },
    },
    computed: {
      // Pie, Doughnut 차트를 위한 별도 옵션
      pieChartOptions() {
        return {
          responsive: true,
          maintainAspectRatio: false,
          aspectRatio: 1, // 1:1 비율 강제
          plugins: {
            legend: {
              display: false,
            },
          },
          // 차트 크기 제한
          layout: {
            padding: 20
          }
        };
      }
    },
    methods: {
      close() {
        this.$emit('close');
      },
    },
  };
</script>

<style lang="scss" scoped>
  .chart-popup-wrapper {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 1000; // 기존 팝업보다 위에 오도록 z-index 설정
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .chart-popup-mask {
    position: absolute;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5);
  }

  .chart-popup-container {
    width: 800px;
    height: 500px;
    background-color: #fff;
    border-radius: 8px;
    box-shadow: 0 4px 15px rgba(0, 0, 0, 0.2);
    z-index: 1;
    display: flex;
    flex-direction: column;
  }

  .chart-popup__header {
    padding: 15px 20px;
    border-bottom: 1px solid #eee;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .chart-popup__title {
    font-size: 16px;
    font-weight: 600;
  }

  .chart-popup__close-btn {
    width: 24px;
    height: 24px;
    cursor: pointer;
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;

    div {
      width: 100%;
      height: 100%;
      position: relative;

      span {
        position: absolute;
        width: 16px;
        height: 2px;
        background-color: #888;
        top: 50%;
        left: 50%;
        transform-origin: center;
        transition: background-color 0.2s;

        &:first-child {
          transform: translate(-50%, -50%) rotate(45deg);
        }

        &:last-child {
          transform: translate(-50%, -50%) rotate(-45deg);
        }
      }
    }

    &:hover div span {
      background-color: #333;
    }
  }

  .chart-popup__content {
    flex: 1;
    padding: 20px;
    position: relative; // 자식 요소의 크기를 100%로 설정하기 위함
    overflow: scroll; // 넘치는 부분 숨김
  }

  .chart-container {
    width: 100%;
    height: 100%;
    position: relative;
    /*display: flex;*/
    justify-content: center;
    align-items: center;
  }

  .chart-popup__no-data {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100%;
    color: #999;
  }
</style>